import { createContext } from "react";
import type { MeQuery } from "@/gql/graphql";

export type MeUser = MeQuery["me"];

type MeProviderContext = {
  me: MeUser;
};

export const MeContext = createContext<MeProviderContext | undefined>(
  undefined
);

export type { MeProviderContext };
